module.exports = __webpack_public_path__ + "static/media/animation3.6ee4c0de.jpg";